import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignProductIdReducer = (state: DesignState, action: PayloadAction<number | undefined>) => {
  state.productId = action.payload;
};

export default setDesignProductIdReducer;
